import MainClass from "./MainClass";

export default class ProfileOrders extends MainClass {
    constructor() {
        super();

        this._POST(this.getOrdersURL, {period: this.period}, this.showOrders);
        this.pagination();
        this.periods();
    }

    periods() {
        const self = this;
        $('.orders_list .orders_list_tab').on('click', '.tab_menu:not(.active)', function () {
            $(this).parent().find('.active').removeClass('active');
            $(this).addClass('active');

            self.period = $(this).attr('data-id');
            self.preloader(true);
            self._POST(self.getOrdersURL, {page: 1, period: self.period}, self.showOrders);
            self.preloader(false);
        });
    }


    pagination() {
        const self = this;
        $('#xhr-orders').on('click', '.catalog_paging li a:not(.active)', function (e) {
            e.preventDefault();
            let page = $(this).parent().attr('data-p');

            self.preloader(true);
            self._POST(self.getOrdersURL, {page: page, period: self.period}, self.showOrders);
            self.preloader(false);
        });
    }

    showOrders(res){
        if(res.success) {
            if(res.data.count_all_time > 0) {
                $('#xhr-orders-empty').hide();
                $('#xhr-orders').html(res.data.html);
                $('.orders_list .title_for_block h1 i').html(res.data.count);
                if(res.data.count === 0) {
                    $('#xhr-orders-empty').show();
                } else {
                    $('#xhr-orders-empty').hide();
                }
            } else {
                $('#xhr-orders').html('');
                $('#xhr-orders-empty').show();
                $('.orders_list .orders_list_tab').hide();
            }
        }
    }
}
